import { ISectionProps, SectionId } from '../../components/molecules/Sidebar/types';
import { BiometricResidencePermitDoc } from '../../types';

export interface IModal {
  isFinanceDocumentModal?: boolean;
  isFollowUpModal?: boolean;
  sponsorType?: string;
  docType?: string | null;
  isComplete?: boolean | null;
  biometricResidencePermit?: BiometricResidencePermitDoc | null;
  sponsorKey?: string;
  docKey?: string | null;
  modalTitle?: string;
  fileNames?: string[];
  isUpload?: boolean;
  shouldShowRequirements?: boolean;
  isInfoOnly?: boolean;
}

export interface UIState {
  readonly isLoading: boolean;
  readonly isContextLoading?: boolean;
  readonly openModal: IModal | null;
  readonly sections: ISectionProps[];
  readonly activeSectionId: SectionId | undefined;
  readonly taskMenuOpen: boolean;
  readonly isTawkLoaded: boolean;
  readonly initNotificationsShown: boolean;
}

export enum UIActionTypes {
  OPEN_DOCUMENT_MODAL = '@@ui/OPEN_DOCUMENT_MODAL',
  CLOSE_MODAL = '@@ui/CLOSE_MODAL',
  OPEN_UPLOAD_MODAL = '@@ui/OPEN_UPLOAD_MODAL',
  OPEN_FINANCE_UPLOAD_MODAL = '@@ui/OPEN_FINANCE_UPLOAD_MODAL',
  OPEN_FOLLOW_UP_UPLOAD_MODAL = '@@ui/OPEN_FOLLOW_UP_UPLOAD_MODAL',
  OPEN_FINANCE_DOCUMENT_MODAL = '@@ui/OPEN_FINANCE_DOCUMENT_MODAL',
  OPEN_FOLLOW_UP_DOCUMENT_MODAL = '@@ui/OPEN_FOLLOW_UP_DOCUMENT_MODAL',
  UPDATE_SECTIONS = '@@ui/UPDATE_SECTIONS',
  TOGGLE_TASK_MENU = '@@ui/TOGGLE_TASK_MENU',
  UPDATE_ACTIVE_SECTION_ID = '@@ui/UPDATE_ACTIVE_SECTION_ID',
  TOGGLE_TAWK_IS_LOADED = '@@ui/TOGGLE_TAWK_IS_LOADED',
  UPDATE_INIT_NOTIFICATIONS_SHOWN = '@@ui/UPDATE_INIT_NOTIFICATIONS_SHOWN',
  SET_IS_LOADING = '@@ui/SET_IS_LOADING',
  SET_CONTEXT_LOADING = '@@auth/SET_CONTEXT_LOADING',
  SET_CONTEXT_SUCCESS = '@@auth/SET_CONTEXT_SUCCESS'
}
